import { RPrinciple } from '../remote/principle';
import { Principle } from '../domain/principle';

export const mapPrinciple = (p: RPrinciple): Principle => ({
    id: p.id,
    documentId: p.documentId,
    title: p.title,
    description: p.description
});

export const mapPrinciples = (principles: RPrinciple[] | null): Principle[] =>
    principles ? principles.map(mapPrinciple) : [];
